let hostname = window.location.hostname;
let api_base_url = false;

console.log("hostname", hostname);

function setBaseUrl() {
  const forceLocalApi = process.env.REACT_APP_FORCE_LOCAL_API === "true";
  const localApiBaseUrl = process.env.REACT_APP_LOCAL_API_BASE_URL || "http://api.sdm.localhost";
  const isLocalhost = hostname.includes("localhost") || hostname === "127.0.0.1";

  if (forceLocalApi) api_base_url = localApiBaseUrl;
  else if (hostname.includes(".dev.") || isLocalhost) api_base_url = "https://api.dev.yellgo.cloud";
  else api_base_url = "https://api.yellgo.cloud";
  console.log("api_base_url", api_base_url);
}

async function get(endpoint) {
  const response = await fetch(api_base_url + endpoint, {
    method: "GET",
    headers: {
      Apiver: 2,
      Hostname: hostname,
    },
  });

  const json = await response.json();

  return json;
}

async function post(endpoint, request) {
  const response = await fetch(api_base_url + endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Apiver: 2,
      Hostname: hostname,
    },
    body: JSON.stringify(request),
  });

  const json = await response.json();

  return json;
}

export default {
  setBaseUrl,
  post,
  get,
};
